import { z } from 'zod'
import { Identity } from '~library/enums'
import { enumWithEmpty } from '~library/models'

/** 企業帳號 - 使用者資訊 Schema */
export const corporateAccountUserProfileSchema = z.object({
  /** 身份 */
  identity: enumWithEmpty(Identity),
  /** 會員姓名 */
  name: z.string(),
  /** 企業代碼 */
  bizId: z.string(),
  /** 企業所屬場站 */
  station: z.string(),
  /** 客戶名稱 */
  corporateLocalName: z.string(),
  /** 客戶英文名稱 */
  corporateEnglishName: z.string(),
  /** JWT token */
  token: z.string(),
  /** refresh token */
  refreshToken: z.string(),
  /** 錯誤次數 */
  errorCount: z.number(),
  /** 密碼修改提醒 */
  latchkeyChangeReminder: z.boolean(),
  /** 登入Key */
  loginKey: z.string()
})

/** 企業帳號 - 使用者資訊 Schema */
export interface CorporateAccountUserProfile
  extends z.infer<typeof corporateAccountUserProfileSchema> {}
